export const EMPTY_STATE = {
  CONTAINER: 'emptyStateContainer',
  PRIMARY_BUTTON_TOOLTIP: 'emptyStatePrimaryButtonTooltip',
  PRIMARY_BUTTON: 'emptyStatePrimaryButton',
  LEARN_MORE_BUTTON: 'emptyStateLearnMoreButton'
} as const;
